import ContactFormSubject from "./ContactFormSubject"

export default class ContactFormEntry {
    public subject: ContactFormSubject;
    public files: File[] = [];
    public question: string = "";
    public firstname: string = "";
    public lastname: string = "";
    public email: string = "";
    public phone: string = "";
    public postalcode: string = "";

    public customerNumber: string = "";
    public rszNumber: string = "";
    public dateOfBirth: Date | null = null;

    public consent: boolean = false;
}